var es = require('elasticsearch');
let index = '';
let type = '';
let AWS = require('aws-sdk');

let AccessKeyId = 'QUtJQVo3UElUWVFKSlE0N0xBS0g=';
let SecretAccessKey = "OE9YWVl1NjJBYVFBRGZWMzEyQ3pjTFpHUzROaUZmNTg5NTVKUWVraA==";

let key = atob(AccessKeyId);
let secret = atob(SecretAccessKey)
AWS.config.update({
    credentials: new AWS.Credentials(key, secret),
    region: 'ap-northeast-2'
});

import {searchElaUrl} from "@/api/config";

const limitCount = 10000;
var client = new es.Client({
    // host: 'https://search-wekifoki-dev-rrmtvy2cuk26h5eznnh6xyclxy.ap-northeast-2.es.amazonaws.com',
    // host: 'https://search-wikifoki-g3qy3aamdikyan4qyc5wpxagza.ap-northeast-2.es.amazonaws.com',
    host: searchElaUrl,
    connectionClass: require('http-aws-es'), // use this connector (required)
    //awsConfig: new AWS.Config({ region }), // set an aws config e.g. for multiple clients to different regions
    httpOptions: {}
});
function init(myIndex, myType) {
    index = myIndex;
    type = myType;
}
function getTotal(body={}) {
    return client.count({
        index: index,
        body: body
    }).then(resp => {
        return resp;
    }, err => {
        return {count: 0,};
    })
}
function search(body = {}) {
    return client.search({
        index: index,
        type: type,
        body: body
    }).then(function (resp) {
        return resp;
    }, function (err) {
        console.trace(err.message);
        return [];
    });
};
function newScroll(body, size) {
    let scrollParams = {
        index: index,
        type: type,
        scroll: '10s',
        size: size,
        body: body,
    }
    return client.search(scrollParams).then(function (resp) {
        return resp;
    }, function (err) {
        console.trace(err.message);
        return [];
    });
}
function scroll(body, size) {
    let scrollParams = {
        index: index,
        type: type,
        scroll: '10s',
        size: size,
        body: body,
    }
    let getFunc = 'search';
    if(body._scroll_id) {
        scrollParams = {
            scrollId: body._scroll_id,
            scroll: "10s",
        };
        getFunc = 'scroll'
    }
    /*return client.search(scrollParams).then(function (resp) {
        return resp;
    }, function (err) {
        console.trace(err.message);
        return [];
    });*/
    return client[getFunc](scrollParams).then(function (resp) {
        return resp;
    }, function (err) {
        console.trace(err.message);
        return [];
    });
}
function clearScrollId(scrollId) {
    let body = {
        scroll_id: scrollId,
    }
    client.clearScroll({body: body}).then(function (resp) {
        return resp;
    }, function (err) {
        console.log(err);
        return false;
    })
}
export {search, getTotal, init, scroll, clearScrollId, newScroll, limitCount}
